import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minCircumferenceValidator(minGetter: () => number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.getRawValue();
    if (value == null || value.min == null || minGetter() == null) {
      return null;
    }
    if (value.min < minGetter()) {
      return {
        minCircumference: {
          message: `Minimum circumference must be greater than ${minGetter() - 1}`,
        },
      };
    }
  };
}

export function minMaxCircumferenceValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.getRawValue();
  if (value == null || value.min == null || value.max == null) {
    return;
  }
  if (value.min >= value.max) {
    return {
      minMaxCircumference: {
        message: 'Maximum circumference must be greater than minimum circumference',
      },
    };
  }
}

export function maxCircumferenceValidator(minGetter: () => number, maxRatioGetter?: () => number) {
  return (control: AbstractControl) => {
    const value = control.getRawValue();
    if (value == null || value.max == null) {
      return;
    }
    const currentMinValue = value.min ?? minGetter();
    const minTo = currentMinValue + 1;
    if (value.max < minTo) {
      return {
        maxCircumference: {
          message: `Maximum circumference must be greater than ${currentMinValue}`,
        },
      };
    }
    if (maxRatioGetter == null || maxRatioGetter() == null) {
      return null;
    }
    if (value.max > Math.ceil(currentMinValue * maxRatioGetter())) {
      return {
        maxRatioCircumference: {
          message: `Maximum circumference exceeds the allowed ratio (max ≤ ${maxRatioGetter()} × min)`,
        },
      };
    }
  };
}
